<template>
  <div>
    <h1 class="page-title display-1">Reservas</h1>
  <visible-for v-show="display" superadmin administrator supervisor commerce installer manager responsible>
    <vuetify-crud-datatable
      ref="datatable"
      slot="content"
      :name="name"
      :plural-name="pluralName"
      :rows-per-page-items='rowsPerPage'
      :translations="translations"
      :headers="item.headers || []"
      :rows="item.items || []"
      :actions="false"
      :item-key="item.item_value"
      :pagination="item.pagination"
      :defaultColumns="item.default_columns || {}"
      :primary-color="color.primary"
      :checkbox-color="color.checkbox"
      :add-dialog="false"
      :edit-dialog="false"
      :display-filters="true"
      :business="businessList"
      :companies="companiesList"
      :commerces="commercesList"
      :installers="installersList"
      :delete-button="(isSuperadmin() || isAdmin()) && showDeleteButton"
      :clone-button="(isSuperadmin() || isAdmin()) && showCloneButton"
      :mark-button="isSuperadmin() || isAdmin()"
      :add-button="!isInstaller() && !isManager() && !isResponsible()"
      :selected-columns="selectedColumns"
      @on-click-add-button="onClickAddButton"
      @on-click-edit-button="onClickEditButton"
      :primary-button-color="color.button.primary"
      :secundary-button-color="color.button.secundary"
      @on-delete="onDeleteItem"
      @on-clone="onCloneItem"
      @on-change-filters="onChangeFilters"
      @on-mark="onMarkItem"
      @on-change-columns="onChangeColumns"
    ></vuetify-crud-datatable>
  </visible-for>

</div>
</template>

<script>
  import Rule from 'mixins/rule'
  import VisibleFor from '@/components/vue-user/visible-for'
  import VuetifyCrudDatatable from '@/components/vuetify-crud-datatable'

  export default {
    mixins: [Rule],

    components:
    {
      VisibleFor,
      VuetifyCrudDatatable
    },

    data () {
      return {
        moment: require('moment'),
        statuses: [],
        taxonomyType: this.$route.params.type || '',
        name: '',
        pluralName: '',
        customColumnsResponse: null,
        item: {},
        dateFrom: null,
        businessList: [],
        companiesList: [],
        commercesList: [],
        installersList: [],
        showCloneButton: true,
        showDeleteButton: true,
        clickTimer: null,
        dateTo: null,
        filterBy: null,
        status: null,
        selectedBusiness: null,
        selectedCompany: null,
        selectedCommerce: null,
        selectedInstaller: null,
        display: false,
        selectedColumns: [],
        translations: {
          new: 'Nueva',
          delete_selecteds: 'Eliminar',
          clone_selecteds: 'Duplicar',
          mark_selecteds: 'Marcar como finalizada',
          delete_element_message: 'Estás a punto de eliminar la',
          edit: 'Editar',
          cancel: 'Cancelar',
          delete: 'Eliminar',
          save: 'Guardar',
          delete_element: '¡ATENCIÓN!',
          search: 'Buscar',
          columns: 'Columnas',
          columns_info: 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro',
          columns_warning: 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto',
          restart_columns: 'Reiniciar columnas',
          reset: 'Reiniciar',
          rows_per_page_items: 'Filas por página',
          no_results_text: 'No hay datos disponibles',
          no_data_text: 'No hay coincidencias',
          no_results_found_for: 'No se encontraron resultados para',
          from: 'Desde',
          to: 'hasta'
        },
        color: {
          checkbox: 'primary',
          primary: 'primary',
          success: 'success',
          error: 'error',
          button: {
            primary: 'primary',
            secundary: 'secundary'
          }
        },
        rowsPerPage: [5, 10, 25, { 'text': 'Todas', 'value': -1 }]
      }
    },

    created () {
      this.getCustomColumns().then((response) => {
        this.getItems().then((response) => {
          this.item = this.normalize(response.data)
          if (this.$route.query.action === 'mark_as_finished') {
            this.dateFrom = null
            this.dateTo = this.moment().format('YYYY-MM-DD')
            this.filterBy = 'booking_installation_end_date'
            this.status = 6
            this.$refs.datatable.setFilters({
              dateFrom: null,
              dateTo: this.moment().format('YYYY-MM-DD'),
              filterBy: 'booking_installation_end_date',
              status: 6,
              business: null,
              company: null,
              commerce: null,
              installer: null
            })
          }
          if (this.$route.query.action === 'set_status') {
            this.dateFrom = this.moment(this.$route.query.from_date).format('YYYY-MM-DD')
            this.dateTo = this.moment(this.$route.query.to_date).format('YYYY-MM-DD')
            this.filterBy = 'booking_installation_start_date'
            this.status = parseInt(this.$route.query.status_id)
            this.$refs.datatable.setFilters({
              dateFrom: this.dateFrom,
              dateTo: this.dateTo,
              filterBy: this.filterBy,
              status: this.status,
              business: null,
              company: null,
              commerce: null,
              installer: null
            })
          }
          if (this.$route.query.action === 'set_business_group') {
            this.dateFrom = this.moment(this.$route.query.from_date).format('YYYY-MM-DD')
            this.dateTo = this.moment(this.$route.query.to_date).format('YYYY-MM-DD')
            this.filterBy = 'booking_installation_start_date'
            this.selectedBusiness = parseInt(this.$route.query.business_group_id)
            this.$refs.datatable.setFilters({
              dateFrom: this.dateFrom,
              dateTo: this.dateTo,
              filterBy: this.filterBy,
              status: null,
              business: this.selectedBusiness,
              company: null,
              commerce: null,
              installer: null
            })
          }
          if (this.$route.query.action === 'set_company') {
            this.dateFrom = this.moment(this.$route.query.from_date).format('YYYY-MM-DD')
            this.dateTo = this.moment(this.$route.query.to_date).format('YYYY-MM-DD')
            this.filterBy = 'booking_installation_start_date'
            this.selectedCompany = parseInt(this.$route.query.company_id)
            this.$refs.datatable.setFilters({
              dateFrom: this.dateFrom,
              dateTo: this.dateTo,
              filterBy: this.filterBy,
              status: null,
              business: null,
              company: this.selectedCompany,
              commerce: null,
              installer: null
            })
          }
          if (this.$route.query.action === 'set_commerce') {
            this.dateFrom = this.moment(this.$route.query.from_date).format('YYYY-MM-DD')
            this.dateTo = this.moment(this.$route.query.to_date).format('YYYY-MM-DD')
            this.filterBy = 'booking_installation_start_date'
            this.selectedCommerce = parseInt(this.$route.query.commerce_id)
            this.$refs.datatable.setFilters({
              dateFrom: this.dateFrom,
              dateTo: this.dateTo,
              filterBy: this.filterBy,
              status: null,
              business: null,
              company: null,
              commerce: this.selectedCommerce,
              installer: null
            })
          }
          if (this.$route.query.action === 'set_installer') {
            this.dateFrom = this.moment(this.$route.query.from_date).format('YYYY-MM-DD')
            this.dateTo = this.moment(this.$route.query.to_date).format('YYYY-MM-DD')
            this.filterBy = 'booking_installation_start_date'
            this.selectedInstaller = parseInt(this.$route.query.installer_id)
            this.$refs.datatable.setFilters({
              dateFrom: this.dateFrom,
              dateTo: this.dateTo,
              filterBy: this.filterBy,
              status: null,
              business: null,
              company: null,
              commerce: null,
              installer: this.selectedInstaller
            })
          }
          this.display = true

          if (this.$route.query.action === 'mark_as_finished') {
            setTimeout(() => {
              this.showCloneButton = false
              this.showDeleteButton = false
            }, 10)
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isSuperadmin () {
        return this.$store.getters['api/getUserRol'] === 'superadmin'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isAdmin () {
        return this.$store.getters['api/getUserRol'] === 'administrator'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isManager () {
        return this.$store.getters['api/getUserRol'] === 'manager'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isResponsible () {
        return this.$store.getters['api/getUserRol'] === 'responsible'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isCommerce () {
        return this.$store.getters['api/getUserRol'] === 'commerce'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isInstaller () {
        return this.$store.getters['api/getUserRol'] === 'installer'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalize (item) {
        this.name = 'reserva'
        this.pluralName = 'reservas'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setDefaultColumns(item)
        item.headers = this.setHeaders(item)
        this.normalizeItems(item)
        this.setTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeItems (item) {
        console.log(item.items)
        item.items.map((obj, index) => {
          if (!this.display) {
            let businessIndex = this.businessList.findIndex(item => item.value === parseInt(obj.business_id))
            let companyIndex = this.companiesList.findIndex(item => item.value === parseInt(obj.company_id))
            let commerceIndex = this.commercesList.findIndex(item => item.value === parseInt(obj.commerce_id))
            let installerIndex = this.installersList.findIndex(item => item.value === parseInt(obj.installer_id))

            if (businessIndex === -1) {
              this.businessList.push({
                text: obj.business_name,
                value: parseInt(obj.business_id)
              })
            }
            if (companyIndex === -1) {
              this.companiesList.push({
                text: obj.company_name,
                value: parseInt(obj.company_id)
              })
            }
            if (commerceIndex === -1) {
              this.commercesList.push({
                text: obj.commerce_name,
                value: parseInt(obj.commerce_id)
              })
            }
            if (installerIndex === -1) {
              this.installersList.push({
                text: parseInt(obj.installer_id) === 1 ? 'Sin asignar' : obj.installer_alias,
                value: parseInt(obj.installer_id)
              })
            }

            this.businessList.sort((a, b) => a.text - b.text)
            this.companiesList.sort((a, b) => a.text - b.text)
            this.commercesList.sort((a, b) => a.text - b.text)
            this.installersList.sort((a, b) => a.text - b.text)
          }
          console.log('ssssssss', this.installersList)
          let date = this.moment(obj[item.item_text_3]).format('YYYY/MM/DD - HH:mm')
          date = date !== 'Invalid date' ? date : '0000/00/00 - 00:00'
          let day = this.moment(obj[item.item_text_3]).locale('es').format('dddd')
          day = day !== 'Invalid date' ? day : 'Sin asignar'

          obj[item.item_text_3] = date + ' - ' + day[0].toUpperCase() + day.substr(1)
          console.log(parseInt(obj[item.item_text_6]))
          switch (parseInt(obj[item.item_text_6])) {
            case 6:
              obj[item.item_text_6] = 'Pendiente'
              break
            case 7:
              obj[item.item_text_6] = 'En transcurso'
              break
            case 8:
              obj[item.item_text_6] = 'Anulada'
              break
            case 9:
              obj[item.item_text_6] = 'Aplazada'
              break
            case 10:
              obj[item.item_text_6] = 'Terminada sin incidencias'
              break
            case 11:
              obj[item.item_text_6] = 'Terminada con incidencias'
              break
            case 13:
              obj[item.item_text_6] = 'Cita programada'
              break
            case 14:
              obj[item.item_text_6] = 'No instalada por iBEC'
              break
          }
          // obj[item.item_text_7] = obj[item.item_text_7] + ' ' + obj[item.item_text_8]
          obj[item.item_text_9] = obj[item.item_text_9] + ' ' + obj[item.item_text_10]
          let equipments = JSON.parse(obj[item.item_text_12])

          if (equipments) {
            obj[item.item_text_12] = equipments[0].brand + ' ' + equipments[0].model
          } else {
            obj[item.item_text_12] = ''
          }
          date = this.moment(obj[item.item_text_13]).format('YYYY/MM/DD')
          date = date !== 'Invalid date' ? date : this.moment().format('YYYY/MM/DD')
          obj[item.item_text_13] = date
          date = this.moment(obj[item.item_text_14]).format('YYYY/MM/DD')
          date = date !== 'Invalid date' ? date : this.moment().format('YYYY/MM/DD')
          obj[item.item_text_14] = date
          date = this.moment(obj[item.item_text_18]).format('YYYY/MM/DD - HH:mm')
          date = date !== 'Invalid date' ? date : this.moment().format('YYYY/MM/DD - HH:mm')
          obj[item.item_text_18] = date
          return obj
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setPagination (item) {
        return {
          sortBy: item.item_value,
          descending: true,
          rowsPerPage: -1
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text_2]: '',
          [item.item_text]: '',
          [item.item_text_3]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setHeaders (item) {
        if (this.isSuperadmin() || this.isAdmin()) {
          return [
            {
              text: 'ID',
              value: item.item_value,
              align: 'left',
              sortable: true,
              type: 'span',
              editable: false
            },
            {
              text: 'Estado',
              align: 'left',
              sortable: true,
              value: item.item_text_6,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha instalación',
              align: 'left',
              sortable: true,
              value: item.item_text_3,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Instalador',
              align: 'left',
              sortable: true,
              value: item.item_text_16,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Cliente',
              align: 'left',
              sortable: true,
              value: item.item_text_9,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Ciudad',
              align: 'left',
              sortable: true,
              value: item.item_text_17,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Comercio',
              align: 'left',
              sortable: true,
              value: item.item_text_2,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Marca y modelo',
              align: 'left',
              sortable: true,
              value: item.item_text_12,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha entrega',
              align: 'left',
              sortable: true,
              value: item.item_text_13,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha de creación',
              align: 'left',
              sortable: true,
              value: item.item_text_18,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Acciones',
              value: 'actions',
              align: 'center',
              type: 'actions',
              sortable: false,
              editable: true,
              fixed: true
            }
          ]
        } else if (this.isManager()) {
          return [
            {
              text: 'ID',
              value: item.item_value,
              align: 'left',
              sortable: true,
              type: 'span',
              editable: false
            },
            {
              text: 'Comercio',
              align: 'left',
              sortable: true,
              value: item.item_text_2,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Estado',
              align: 'left',
              sortable: true,
              value: item.item_text_6,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Marca y modelo',
              align: 'left',
              sortable: true,
              value: item.item_text_12,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha venta',
              align: 'left',
              sortable: true,
              value: item.item_text_14,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha instalación',
              align: 'left',
              sortable: true,
              value: item.item_text_3,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Instalador',
              align: 'left',
              sortable: true,
              value: item.item_text_16,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Dirección',
              align: 'left',
              sortable: true,
              value: item.item_text_15,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Ciudad',
              align: 'left',
              sortable: true,
              value: item.item_text_17,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Acciones',
              value: 'actions',
              align: 'center',
              type: 'actions',
              sortable: false,
              editable: true,
              fixed: true
            }
          ]
        } else if (this.isResponsible()) {
          return [
            {
              text: 'ID',
              value: item.item_value,
              align: 'left',
              sortable: true,
              type: 'span',
              editable: false
            },
            {
              text: 'Comercio',
              align: 'left',
              sortable: true,
              value: item.item_text_2,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Estado',
              align: 'left',
              sortable: true,
              value: item.item_text_6,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Marca y modelo',
              align: 'left',
              sortable: true,
              value: item.item_text_12,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha venta',
              align: 'left',
              sortable: true,
              value: item.item_text_14,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha instalación',
              align: 'left',
              sortable: true,
              value: item.item_text_3,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Instalador',
              align: 'left',
              sortable: true,
              value: item.item_text_16,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Dirección',
              align: 'left',
              sortable: true,
              value: item.item_text_15,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Ciudad',
              align: 'left',
              sortable: true,
              value: item.item_text_17,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Acciones',
              value: 'actions',
              align: 'center',
              type: 'actions',
              sortable: false,
              editable: true,
              fixed: true
            }
          ]
        } else if (this.isCommerce()) {
          return [
            {
              text: 'ID',
              value: item.item_value,
              align: 'left',
              sortable: true,
              type: 'span',
              editable: false
            },
            {
              text: 'Cliente',
              align: 'left',
              sortable: true,
              value: item.item_text_9,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Estado',
              align: 'left',
              sortable: true,
              value: item.item_text_6,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Marca y modelo',
              align: 'left',
              sortable: true,
              value: item.item_text_12,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha venta',
              align: 'left',
              sortable: true,
              value: item.item_text_14,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha instalación',
              align: 'left',
              sortable: true,
              value: item.item_text_3,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Instalador',
              align: 'left',
              sortable: true,
              value: item.item_text_16,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Dirección',
              align: 'left',
              sortable: true,
              value: item.item_text_15,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Ciudad',
              align: 'left',
              sortable: true,
              value: item.item_text_17,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Acciones',
              value: 'actions',
              align: 'center',
              type: 'actions',
              sortable: false,
              editable: true,
              fixed: true
            }
          ]
        } else if (this.isInstaller()) {
          return [
            {
              text: 'ID',
              value: item.item_value,
              align: 'left',
              sortable: true,
              type: 'span',
              editable: false
            },
            {
              text: 'Estado',
              align: 'left',
              sortable: true,
              value: item.item_text_6,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha instalación',
              align: 'left',
              sortable: true,
              value: item.item_text_3,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Marca y modelo',
              align: 'left',
              sortable: true,
              value: item.item_text_12,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Fecha entrega',
              align: 'left',
              sortable: true,
              value: item.item_text_13,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Ciudad',
              align: 'left',
              sortable: true,
              value: item.item_text_17,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Dirección',
              align: 'left',
              sortable: true,
              value: item.item_text_15,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Cliente',
              align: 'left',
              sortable: true,
              value: item.item_text_9,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Comercio',
              align: 'left',
              sortable: true,
              value: item.item_text_2,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Empresa',
              align: 'left',
              sortable: true,
              value: item.item_text,
              type: 'span',
              editable: false,
              main: true,
              rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
              counter: 255
            },
            {
              text: 'Acciones',
              value: 'actions',
              align: 'center',
              type: 'actions',
              sortable: false,
              editable: true,
              fixed: true
            }
          ]
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setTranslations () {
        this.translations.new = 'Nueva'
        this.translations.delete_selecteds = 'Eliminar'
        this.translations.delete_element_message = 'Estás a punto de eliminarla'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomColumns () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/option/' + userID + '/bookings_columns/'
          }).then((response) => {
            this.customColumnsResponse = response.data
            this.selectedColumns = JSON.parse(this.customColumnsResponse.user_option_value)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener la disposición de las columnas: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateCustomColumns () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'put',
            url: 'user/option/' + userID + '/bookings_columns/',
            data: {
              option_id: this.customColumnsResponse.user_option_id,
              option_value: JSON.stringify(this.selectedColumns)
            }
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al actualizar la disposición de las columnas: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getItems () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'post',
            url: 'get-sales/',
            data: {
              date_from: this.dateFrom || '',
              date_to: this.dateTo || '',
              filter_by: this.filterBy || '',
              status: this.status || '',
              business: this.selectedBusiness || '',
              company: this.selectedCompany || '',
              commerce: this.selectedCommerce || '',
              installer: this.selectedInstaller || ''
            }
          }).then((response) => {
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el perfil: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDeleteItem (index) {
        let id = this.item.items[index][this.item.item_value]
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'sale/' + id + '/'
        }).then((response) => {
          console.log(response.data)
          this.$store.dispatch(
            'snackbar/show',
            '¡Eliminado!'
          )
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al eliminar: ' + this.$store.getters['api/getMessage']
          )
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onMarkItem (item) {
        let id = item[this.item.item_value]
        console.log(id)
        this.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'change-booking-status/' + id + '/10/'
        }).then((response) => {
          console.log(response)
          this.getItems().then((response) => {
            this.item = this.normalize(response.data)
          }).catch((error) => {
            console.log(error)
          })
          this.$store.dispatch(
            'snackbar/show',
            '¡Marcada como finalizada!'
          )
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeFilters (filters) {
        this.dateFrom = filters.dateFrom || null
        this.dateTo = filters.dateTo || null
        this.filterBy = filters.filterBy || null
        this.status = filters.status || null
        this.selectedBusiness = filters.business || null
        this.selectedCompany = filters.company || null
        this.selectedCommerce = filters.commerce || null
        this.selectedInstaller = filters.installer || null
        clearTimeout(this.clickTimer)
        this.clickTimer = setTimeout(() => {
          this.getItems().then((response) => {
            this.item = this.normalize(response.data)
            if (this.$route.query.action === 'mark_as_finished') {
              setTimeout(() => {
                this.$refs.datatable.selectAll()
              }, 1000)
            }
          }).catch((error) => {
            console.log(error)
          })
        }, 100)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onCloneItem (index) {
        let id = this.item.items[index][this.item.item_value]
        this.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'sale/duplicate/' + id + '/1/1/1/'
        }).then((response) => {
          this.getItems().then((response) => {
            this.item = this.normalize(response.data)
          }).catch((error) => {
            console.log(error)
          })
          this.$store.dispatch(
            'snackbar/show',
            'Duplicada!'
          )
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al duplicar: ' + this.$store.getters['api/getMessage']
          )
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeColumns (customColumns) {
        this.selectedColumns = customColumns
        this.updateCustomColumns()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickAddButton () {
        this.$router.push(
          {
            name: 'booking-id',
            params: {
              booking_id: 'new'
            }
          }
        )
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickEditButton (index, id) {
        this.$router.push(
          {
            name: 'booking-id',
            params: {
              booking_id: id
            }
          }
        )
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

</style>



// WEBPACK FOOTER //
// src/pages/bookings.vue